export default __webpack_public_path__ + "static/media/Pen.7836ce1b.svg";